// @flow
import React from 'react';

import StopsTypeahead from '../StopsTypeahead';
import ScheduleTable from './ScheduleTable';

import * as styles from './studentStopsScheduling.css';

type StudentStopsSchedulingPropTypes = {
  value: Object,
  headerLabel?: String,
  routeType?: 'going' | 'returning',
  onChange: Function,
};

const StudentStopsScheduling = ({
  value,
  headerLabel = '',
  routeType = 'going',
  onChange,
}: StudentStopsSchedulingPropTypes) => (
  <div>
    <div className={styles.tableContainer}>
      <ScheduleTable
        value={value}
        title={headerLabel}
        onChange={onChange}
      />
    </div>
    <div className={styles.typeaheadContainer}>
      <StopsTypeahead
        onSelect={(selected) => {
          const repeted = value
            ? value[selected.id]
            : null;

          if (!repeted && Object.keys(value).length <= 7) {
            onChange({
              ...value,
              [selected.id]: { ...selected },
            });
          }
        }}
        routeType={routeType}
      />
    </div>
  </div>
);

export default StudentStopsScheduling;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentStopsScheduling/index.jsx